import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Dropdown, DropdownButton, Row} from "react-bootstrap";
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { axiosAuth_PLATFORM_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import { testJSON } from '../utils/jsUtils';


const NotifTypeAdmin_NewNotifTypeView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get error.
  const [notifTypeAttrs, setNotifTypeAttrs] = useState({
    name: '',
    description: '',
    category: '',
    attrList: '',
    msgTemplates: {},
    timeBased: true,
    status: ''
  });

  const categoryOptions = [
    { key: "ALARM",     value: "ALARM" },
/*
    { key: "WORKORDER", value: "WORKORDER" },
*/
    { key: "OTHER",     value: "OTHER" }
  ];

  const statusOptions = [
    { key: "ST_ENABLED",  value: "ST_ENABLED" },
    { key: "ST_DISABLED", value: "ST_DISABLED" }
  ];

  const [alarmMsgTemplate, setAlarmMsgTemplate] = useState({});


  // Initialize state
  useEffect(() => {
    fetchMsgTempl();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function fetchMsgTempl() {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.get("public-config");

        resolve(res.data);

        if (res.status === 200) {
          if (res.data[0] && res.data[0].notifMsgTemplates) {
            setAlarmMsgTemplate(res.data[0].notifMsgTemplates.alarmMsgTemplate);
          } else {
            setErrMsg(t("I18N_ERR_fetch_alarm_msg_templ"));
          }
        }
        setErrMsg('');
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }

  // UI Functions

  const [errMsg, setErrMsg] = useState('');

  const onAttrsInputChange = (e) => {
    setNotifTypeAttrs({ ...notifTypeAttrs, [e.target.name]: e.target.value })
  }

/*
  const onCheckboxSelectNew = (e) => {
    setNotifTypeAttrs({ ...notifTypeAttrs, [e.target.name]: e.target.checked });
  }
*/

  const onCategorySelect = (key, event) => {
    // Deep copy
    let tmpAttrs =  JSON.parse (JSON.stringify(notifTypeAttrs));
    tmpAttrs.category = key;

    if ((key === 'ALARM') && (JSON.stringify(notifTypeAttrs.msgTemplates) === "{}")) {
      tmpAttrs.msgTemplates = alarmMsgTemplate;
    } else {
      tmpAttrs.msgTemplates = {};
    }

    setNotifTypeAttrs(tmpAttrs);
  }

  const onStatusSelect = (key, event) => {
    setNotifTypeAttrs({ ...notifTypeAttrs, status: key });
  }

  const onMsgTemplatesEmailSubject = (e) => {
    // Deep copy
    let tmpMsgTemplate =  JSON.parse (JSON.stringify(notifTypeAttrs.msgTemplates));

    if (!tmpMsgTemplate.email)
      tmpMsgTemplate.email = {}

    tmpMsgTemplate.email.subject = e.target.value;

    setNotifTypeAttrs({ ...notifTypeAttrs, msgTemplates: tmpMsgTemplate });
  }

  const onMsgTemplatesEmailBody = (e) => {
    // Deep copy
    let tmpMsgTemplate =  JSON.parse (JSON.stringify(notifTypeAttrs.msgTemplates));

    if (!tmpMsgTemplate.email)
      tmpMsgTemplate.email = {}

    tmpMsgTemplate.email.body = e.target.value;

    setNotifTypeAttrs({ ...notifTypeAttrs, msgTemplates: tmpMsgTemplate });
  }

  const onMsgTemplatesSMS = (e) => {
    // Deep copy
    let tmpMsgTemplate =  JSON.parse (JSON.stringify(notifTypeAttrs.msgTemplates));

    if (!tmpMsgTemplate.sms)
      tmpMsgTemplate.sms = {}

    tmpMsgTemplate.sms.body = e.target.value;

    setNotifTypeAttrs({ ...notifTypeAttrs, msgTemplates: tmpMsgTemplate });
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!notifTypeAttrs.name || notifTypeAttrs.name.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name"));
    } else if (notifTypeAttrs.name.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_name") + 50);
    } else if (!notifTypeAttrs.description || notifTypeAttrs.description.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_description"));
    } else if (notifTypeAttrs.description.length > 200) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + 200);
    } else if (!notifTypeAttrs.status || notifTypeAttrs.status.length === 0) {
      setErrMsg(t("I18N_ERR_Need_status"));
    } else if (!notifTypeAttrs.category || notifTypeAttrs.category.length === 0) {
      setErrMsg(t("I18N_ERR_Need_category"));
    } else if (!notifTypeAttrs.msgTemplates || notifTypeAttrs.msgTemplates.length === 0) {
      setErrMsg(t("I18N_ERR_Need_msgTemplate"));
    } else if (   (notifTypeAttrs.category === 'ALARM')
               && (Object.keys(notifTypeAttrs.msgTemplates).length === 0)) {
      setErrMsg(t("I18N_ERR_Need_msgTemplate"));
    } else if (!testJSON(JSON.stringify(notifTypeAttrs.msgTemplates))) {
      setErrMsg(t("I18N_ERR_Msg_templates_invalid_JSON"));
    } else {
      validateName();
    }

    return;
  }

  // Since this is async, need to call this first, and check the others when username availability returns
  function validateName() {

    new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("notif-types?name=" + notifTypeAttrs.name);

        resolve(res.data);

        if (res.data && res.data.length > 0) {
          // NotifType name is taken
          setErrMsg(t("I18N_ERR_Name_taken"));
          return;
        } else {
          validateOtherFields();
          return;
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
          validateOtherFields();
        }
        return;
      }
    });
  }

  function validateOtherFields() {
    // Validate form inputs

    createNewNotifType();
  }

  const createNewNotifType = () => {

    // Make a deep copy
    const reqBody = JSON.parse(JSON.stringify(notifTypeAttrs));

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.post("notif-types", reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Return to list
          navigate(-1);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleCancel = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_New_Notiftype")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Notiftype_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
        </div>

        <Container>
          <form>
            <Row className={classes.admin_pages__field_label}>
              <Col md={3}>{t("I18N_Name")}: *</Col>
              <Col md={3}>{t("I18N_Description")}: *</Col>
{/* Removed this feature.  Always time based.
              <Col md={3}>{t("I18N_Time_based")}: *</Col>
*/}
              <Col md={3}>{t("I18N_Notif_type_cat")}: *</Col>
              <Col md={3}>
              </Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col md={3}>
                <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="name" value={notifTypeAttrs.name}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col md={3}>
                <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="description" value={notifTypeAttrs.description}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
{/* Removed this feature.  Always time based.
              <Col md={3}><Form.Check type="switch" name={"timeBased"} checked={notifTypeAttrs.timeBased}
                   onChange={onCheckboxSelectNew} />
              </Col>
*/}
              <Col md={3}>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={!notifTypeAttrs.category ? t("common:I18N_DROPDOWN_PROMPT") :
                          t("I18N_" + categoryOptions.find( ({ key }) => key === notifTypeAttrs.category ).value)}
                  onSelect={onCategorySelect}>
                  {categoryOptions.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                        {t("I18N_" + item.value)}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Col>
              <Col md={3}>
              </Col>
            </Row>


            <Row className={classes.admin_pages__field_label}>
              <Col md={3}>{t("I18N_Status")}: *</Col>
              <Col md={3}></Col>
              <Col md={3}></Col>
              <Col md={3}></Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col md={3}>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={!notifTypeAttrs.status ? t("common:I18N_DROPDOWN_PROMPT") :
                          t("I18N_" + (statusOptions.find( ({ key }) => key === notifTypeAttrs.status )).value)}
                  onSelect={onStatusSelect}>
                  {statusOptions.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                        {t("I18N_" + item.value)}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Col>
              <Col md={3}></Col>
              <Col md={3}></Col>
              <Col md={3}></Col>
            </Row>


{/*
            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              <Col sm={{span: 12}}>{t("I18N_Attr_list")}:</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col sm={{span: 12}}>
                <textarea rows={2} className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="attrList"
                          value={notifTypeAttrs.attrList} onChange={(e) => onAttrsInputChange(e)} />
              </Col>
            </Row>
*/}

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              <Col sm={{span: 12}}>{t("I18N_Msg_templates")}: *</Col>
            </Row>
{/*
            <Row className={classes.admin_pages__field_value}>
              <Col sm={{span: 12}}>
                <textarea rows={6} className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="msgTemplates"
                          value={notifTypeAttrs.msgTemplates} onChange={(e) => onAttrsInputChange(e)} />
              </Col>
            </Row>
*/}
            <div style={{marginLeft: '0px', marginTop: '5px', padding: '10px', border:'1px solid #AAA', borderRadius:'5px' }}>
              <Row className={classes.admin_pages__field_label} style={{ marginTop: '0px', textDecorationLine: 'underline' }}>
                <Col sm={{span: 12}}>{t("I18N_Email")}</Col>
              </Row>
              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col sm={{span: 1}}>{t("I18N_Subject")}:</Col>
                <Col sm={{span: 11}}>
                  <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="code"
                    value={notifTypeAttrs.msgTemplates && notifTypeAttrs.msgTemplates.email ? notifTypeAttrs.msgTemplates.email.subject : ''}
                    onChange={(e) => onMsgTemplatesEmailSubject(e)} />
                </Col>
              </Row>
              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col sm={{span: 1}}>{t("I18N_Msg_body")}:</Col>
                <Col sm={{span: 11}}>
                  <textarea rows={6} className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="msgTemplates"
                            value={notifTypeAttrs.msgTemplates && notifTypeAttrs.msgTemplates.email ? notifTypeAttrs.msgTemplates.email.body : ''} onChange={(e) => onMsgTemplatesEmailBody(e)} />
                </Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px', textDecorationLine: 'underline' }}>
                <Col sm={{span: 12}}>{t("I18N_SMS")}</Col>
              </Row>
              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col sm={{span: 1}}>{t("I18N_Msg_body")}:</Col>
                <Col sm={{span: 11}}>
                  <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="code"
                    value={notifTypeAttrs.msgTemplates && notifTypeAttrs.msgTemplates.sms ? notifTypeAttrs.msgTemplates.sms.body : ''}
                    onChange={(e) => onMsgTemplatesSMS(e)} />
                </Col>
              </Row>
            </div>

            <hr className="solid" style={{ marginTop: '30px' }}></hr>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px', fontStyle: 'italic' }}>
              <span>{t("I18N_Req_fields")}</span>
            </Row>

            <Row>
              <div display='flex' style={{ marginTop: '15px' }}>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ float: 'left' }}
                  onClick={handleCancel}>
                  {t("I18N_Cancel")}
                </Button>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ marginLeft: '15px' }}
                  onClick={handleSubmit}>
                  {t("I18N_Submit")}
                </Button>
                <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                  {errMsg}
                </span>
              </div>
            </Row>
          </form>
        </Container>

      </Card>
    </>
  );
}

export default NotifTypeAdmin_NewNotifTypeView;
